import moment from 'moment';
import React from 'react';
import appJson from '../../package.json';
import { MONTH_NAMES, MONTH_NAMES_ABBR, THIS_MONTH, THIS_YEAR } from './calendar';
import { CategoryImage, ContributionsImage, CreatePostImage, GiftPostImage, NotificationsImage } from 'assets/images/helpVideos/thumbnails';
import {
  Basics,
  Bigs,
  Birthdays,
  Celebrations,
  Faves,
  Fitness,
  Growth,
  Hardships,
  Health,
  Journeys,
  Learning,
  Moments,
  Other,
  Places,
  Purpose,
  Relationships,
  Spirituality,
  Work,
} from 'components/UI/ContentCategoryImages/ContentCategoryImages';
import { Calendar, Camera, Lightbulb, List, Map, Tags, UserGroup } from 'components/UI/FormImages/FormImages';
import {
  Anchor,
  BabyCarriage,
  Backpack,
  Badge,
  BaseballBall,
  Bicycle,
  BirthdayCake,
  Bookmark,
  Books,
  Building,
  BullseyeArrow,
  Campground,
  CarSide,
  Child,
  Dove,
  Dumbbell,
  FireAlt,
  FlowerDaffodil,
  Ghost,
  GlassCheers,
  Hammer,
  HandHeart,
  HandSparkles,
  HandsHelping,
  Heart,
  HeartBroken,
  Hiking,
  Home,
  HomeHeart,
  Hospital,
  Key,
  Landmark,
  Lightbulb2,
  MapPin,
  Medal,
  MoonStars,
  Mountain,
  MugHot,
  Music,
  NotesMedical,
  Palette,
  Paw,
  PlanetMoon,
  PrayingHands,
  Rainbow,
  RocketLaunch,
  SackDollar,
  Seedling,
  ShoePrints,
  Snowflake,
  Spa,
  StarOfLife,
  StarShooting,
  Sun,
  Telescope,
  Ticket,
  Toolbox,
  Tree,
  UserCircle,
  UserFriends,
  UserGraduate,
  UserMd,
  Users,
  Utensils,
  Water,
  Wifi,
} from 'components/UI/ImportantPlaceIcons/ImportantPlaceIcons';
import {
  AnchorMarker,
  BabyCarriageMarker,
  BackpackMarker,
  BadgeMarker,
  BaseballBallMarker,
  BicycleMarker,
  BirthdayCakeMarker,
  BookmarkMarker,
  BooksMarker,
  BuildingMarker,
  BullseyeArrowMarker,
  CampgroundMarker,
  CarSideMarker,
  ChildMarker,
  DoveMarker,
  DumbbellMarker,
  FireAltMarker,
  FlowerDaffodilMarker,
  GhostMarker,
  GlassCheersMarker,
  HammerMarker,
  HandHeartMarker,
  HandSparklesMarker,
  HandsHelpingMarker,
  HeartBrokenMarker,
  HeartMarker,
  HikingMarker,
  HomeHeartMarker,
  HomeMarker,
  HospitalMarker,
  KeyMarker,
  LandmarkMarker,
  LightbulbMarker,
  MapPinMarker,
  MoonStarsMarker,
  MugHotMarker,
  MusicMarker,
  NotesMedicalMarker,
  PaletteMarker,
  PawMarker,
  PlanetMoonMarker,
  PrayingHandsMarker,
  RainbowMarker,
  RocketLaunchMarker,
  SackDollarMarker,
  SeedlingMarker,
  ShoePrintsMarker,
  SnowflakeMarker,
  SpaMarker,
  StarOfLifeMarker,
  StarShootingMarker,
  SunMarker,
  TelescopeMarker,
  TicketMarker,
  ToolboxMarker,
  TreeMarker,
  UserCircleMarker,
  UserFriendsMarker,
  UserGraduateMarker,
  UserMdMarker,
  UsersMarker,
  UtensilsMarker,
  WaterMarker,
  WifiMarker,
} from 'components/UI/MapMarkerSVGs/MapMarkerSVGs';
import { MountainMarker } from 'components/UI/MapMarkerSVGs/MountainMarker';

/* eslint-disable no-use-before-define,no-plusplus */

export const getBuildNumber = () => {
  return appJson.version;
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const updateControls = (event, controlName, controls, password) => {
  const updatedControls = updateObject(controls, {
    [controlName]: updateObject(controls[controlName], {
      value: event.target.value,
      valid: checkValidity(event.target.value, controls[controlName].validation, password),
      touched: true,
    }),
  });
  return updatedControls;
};

export const isMobileDevice = (navigatorUserAgent) => {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

  return toMatch.some((toMatchItem) => {
    return navigatorUserAgent.match(toMatchItem);
  });
};

export const insertArrayItem = (array, index, item) => {
  const newArray = array.slice();
  newArray.splice(index, 0, item);
  return newArray;
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const removeArrayItem = (array, index) => {
  const newArray = array.slice();
  newArray.splice(index, 1);
  return newArray;
};

export const combineAndDedupArrays = (array1, array2) => {
  const dedupedArray2 = array2.length > 0 ? array2.filter((item) => array1.includes(item) !== true) : [];
  return array1.concat(dedupedArray2);
};

export const dedupArray = (arr) => {
  const dedupedArray = [];
  arr.forEach((arrItem) => {
    if (!dedupedArray.includes(arrItem)) {
      dedupedArray.push(arrItem);
    }
  });
  return dedupedArray;
};

export const doArraysHaveOverlappingValues = (arr1, arr2) => {
  const map = {};

  const [smallArray, bigArray] = arr1.length < arr2.length ? [arr1, arr2] : [arr2, arr1];

  for (let i = 0; i < smallArray.length; i++) {
    if (!map[smallArray[i]]) {
      map[smallArray[i]] = true;
    }
  }

  for (let i = 0; i < bigArray.length; i++) {
    if (map[bigArray[i]]) {
      return true;
    }
  }

  return false;
};

export const changeArrayPosition = (arr, oldIndex, newIndex) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr; // for testing
};

const validateEmail = (email) => {
  const re =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const getAuthorName = (NickName, FirstName) => {
  return NickName !== '' ? NickName : FirstName;
};

// export const replaceVarPlaceholdersWithVars = (string, varsObject) => {
// 	let varCount =
// }

export const numberToPhoneNumber = (value) => {
  // return nothing if no value
  if (!value) return value;

  // only allows 0-9 inputs
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (cvLength > 0) {
    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
  return '';
};

export const prependZeroToSingleDigitNumber = (number) => {
  let twoDigitNumber = number;
  if (number.toString().length === 1) {
    twoDigitNumber = `0${number}`;
  }
  return twoDigitNumber;
};

export const preparePostDateForSubmission = (date, ongoing) => {
  if (!date || date === '') {
    return '';
  }
  if (ongoing === true) {
    return 'Ongoing';
  }
  if (typeof date === 'string' && date.includes('/0/')) {
    const month = `0${date.split('/')[0]}`.slice(-2);
    return `${month}/0/${date.split('/')[2]}`;
  }
  let returnedDate = new Date(date);
  returnedDate = `${prependZeroToSingleDigitNumber(returnedDate.getMonth() + 1)}/${prependZeroToSingleDigitNumber(
    returnedDate.getDate(),
  )}/${returnedDate.getFullYear()}`;
  return returnedDate;
};

export const extractTimeFromDateTime = (dateTime) => {
  const date = new Date(dateTime);
  if (!dateTime || dateTime === '') {
    return null;
  }
  return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
};

export const utcToLocalDateTime = (utcDateTime) => {
  if (utcDateTime === '') {
    return utcDateTime;
  }

  const utcDateTimeString = `${utcDateTime} UTC`;
  const localDateTime = new Date(utcDateTimeString);
  return localDateTime;
};

export const isNullTime = (timeString) => {
  return !!(!timeString || timeString === '');
};

export const separateNewLinesIntoParagraphs = (textString) => {
  let newText = null;
  if (textString) {
    const textStringLinesArray = textString.split('\n');
    newText = textStringLinesArray.map((item, i) => {
      // eslint-disable-next-line react/no-array-index-key
      return <p key={i}>{item}</p>;
    });
  }
  return newText;
};

export const generateRandomString = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getDaysSince = (stringDate) => {
  const date = new Date(stringDate);
  const timeZoneOffset = date.getTimezoneOffset();
  const seconds = Math.floor((new Date() - (date - timeZoneOffset * 60 * 1000)) / 1000);

  const interval = Math.floor(seconds / 86400);

  return interval;
};

export const getTimeSince = (stringDate) => {
  const date = new Date(stringDate);
  const timeZoneOffset = date.getTimezoneOffset();
  const seconds = Math.floor((new Date() - (date - timeZoneOffset * 60 * 1000)) / 1000);

  let interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return `${interval} years`;
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return `${interval} months`;
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return `${interval} days`;
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return `${interval} hours`;
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return `${interval} minutes`;
  }
  return `${Math.floor(seconds)} seconds`;
};

export const truncateText = (str, length, ending) => {
  if (str) {
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str && str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    }
    return str;
  }
  return '';
};

export const checkValidity = (value, rules, password) => {
  if (!rules) {
    return true;
  }
  let isValid = true;
  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
  }
  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }
  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }
  if (rules.isEmail) {
    isValid = validateEmail(value);
  }
  if (rules.isPhone) {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const phoneNumber = value.replace(/[^\d]/g, '').replace('+1', '');
    if (!pattern.test(phoneNumber) || phoneNumber.length !== 10) {
      isValid = false;
    } else {
      isValid = true;
    }
  }
  if (rules.isPassword) {
    const updatedValue = value.trim();
    // const specialCharacterFormat = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const hasOneNumber = /\d/;
    const hasOneLowerCaseLetter = /[a-z]/;
    const hasOneUpperCaseLetter = /[A-Z]/;
    isValid =
      updatedValue.length >= 8 &&
      hasOneNumber.test(updatedValue) &&
      hasOneLowerCaseLetter.test(updatedValue) &&
      hasOneUpperCaseLetter.test(updatedValue);
  }
  if (rules.matchesPassword && password !== null) {
    const updatedValue = value.trim();
    isValid = updatedValue === password.trim();
  }
  return isValid;
};

export const updatedControlsForInput = (value, controlName, controls) => {
  const updatedControls = updateObject(controls, {
    [controlName]: updateObject(controls[controlName], {
      value,
      valid: checkValidity(value, controls[controlName].validation),
      touched: true,
    }),
  });
  return updatedControls;
};

export const formatDateForDatePicker = (inputDate) => {
  const date = new Date(inputDate);
  if (!Number.isNaN(date.getTime())) {
    // Months use 0 index.
    let month = (date.getMonth() + 1).toString();
    if (month.length === 1) month = `0${month}`;
    let day = date.getDate().toString();
    if (day.length === 1) day = `0${day}`;
    return `${date.getFullYear()}-${month}-${day}`;
  }
  return '';
};

export const addCurrentTimeToDateString = (dateString) => {
  const date = new Date();
  let hours = date.getHours().toString();
  if (hours.length === 1) hours = '0';
  let minutes = date.getMinutes().toString();
  if (minutes.length === 1) minutes = `0${minutes}`;
  let seconds = date.getSeconds().toString();
  if (seconds.length === 1) seconds = `0${seconds}`;
  return `${dateString} ${hours}:${minutes}:${seconds}`;
};

export const formatDateForApi = (datePickerDate) => {
  if (datePickerDate === '' || datePickerDate === null) {
    return null;
  }
  const date = new Date(datePickerDate);
  if (!Number.isNaN(date.getTime())) {
    // Months use 0 index.
    let month = (date.getMonth() + 1).toString();
    if (month.length === 1) month = `0${month}`;
    let day = date.getDate().toString();
    if (day.length === 1) day = `0${day}`;
    let hours = date.getHours().toString();
    if (hours.length === 1) hours = '0';
    let minutes = date.getMinutes().toString();
    if (minutes.length === 1) minutes = `0${minutes}`;
    let seconds = date.getSeconds().toString();
    if (seconds.length === 1) seconds = `0${seconds}`;
    return `${month}/${day}/${date.getFullYear()} ${hours}:${minutes}:${seconds}`;
  }
  return null;
};

export const formatDateForDisplay = (date, isNullDay, isNullMonth) => {
  if (date.toString().toLowerCase() === 'ongoing') {
    return 'Ongoing';
  }
  const updatedDate = new Date(date);

  const isMonthYear = (date && typeof date === 'string' && date.split('/')[1] === '0') || isNullDay;
  if (date) {
    if (!isMonthYear) {
      return `${MONTH_NAMES[updatedDate.getMonth()]} ${updatedDate.getDate()}, ${updatedDate.getFullYear()}`;
    }
    const dateString = isNullDay && isNullMonth ? `0/0/${date.split('/')[2]}` : isNullMonth ? `${date.split('/')[0]}/0/${date.split('/')[2]}` : date;
    return displayDateFromMonthYear(dateString);
  }
  return '';
};

export const formatLongFormDate = (dateCalc, longFormMonth) => {
  if (dateCalc === 'Ongoing') return dateCalc;
  if (dateCalc) {
    const month = dateCalc.split('/')[0] ? parseInt(dateCalc.split('/')[0], 10) : null;
    const day = dateCalc.split('/')[1] ? dateCalc.split('/')[1] : null;
    const isYearOnly = dateCalc.split('/')[0] === '0' && dateCalc.split('/')[1] === '0';
    const isMonthYear = dateCalc.split('/')[1] === '0' && !isYearOnly;
    if (isYearOnly) {
      return dateCalc.split('/')[2];
    }
    if (isMonthYear) {
      return `${longFormMonth ? MONTH_NAMES[month - 1] : MONTH_NAMES_ABBR[month - 1]} ${dateCalc.split('/')[2]}`;
    }
    return `${longFormMonth ? MONTH_NAMES[month - 1] : MONTH_NAMES_ABBR[month - 1]} ${day}, ${dateCalc.split('/')[2]}`;
  }
  return '';
};

export const formatShortFormDate = (dateCalc) => {
  let formattedDate = null;
  if (dateCalc === 'Ongoing') {
    formattedDate = dateCalc;
  } else if (dateCalc) {
    const month = dateCalc.split('/')[0] ? dateCalc.split('/')[0] : null;
    const day = dateCalc.split('/')[1] ? dateCalc.split('/')[1] : null;
    const year = dateCalc.split('/')[2] ? dateCalc.split('/')[2] : null;
    if (month === '0') {
      formattedDate = year;
    } else if (day === '0') {
      formattedDate = `${month}/${year}`;
    } else {
      formattedDate = `${month}/${day}/${year}`;
    }
  }
  return formattedDate;
};

export const areSameMonth = (DateStartCalc, DateEndCalc) => {
  const dateStartMonth = DateStartCalc.split('/')[0] ? DateStartCalc.split('/')[0] : null;
  const dateEndMonth = DateEndCalc === 'Ongoing' || !DateEndCalc.split('/')[0] ? null : DateEndCalc.split('/')[0];
  return dateStartMonth === dateEndMonth;
};

export const areSameYear = (DateStartCalc, DateEndCalc) => {
  const dateStartYear = !DateStartCalc.split('/')[2] ? null : DateStartCalc.split('/')[2];
  const dateEndYear = DateEndCalc === 'Ongoing' || !DateEndCalc.split('/')[2] ? null : DateEndCalc.split('/')[2];
  return dateStartYear === dateEndYear;
};

export const sharedMonthAndYearDateFormat = (DateStartCalc, DateEndCalc, longFormMonth) => {
  // Format Example: Nov 1-30, 2020
  const startDay = DateStartCalc && DateStartCalc.split('/')[1] ? DateStartCalc.split('/')[1] : '';
  const endDay = DateEndCalc && DateEndCalc.split('/')[1] ? DateEndCalc.split('/')[1] : '';
  const monthName =
    DateStartCalc && DateStartCalc.split('/')[0] && parseInt(DateStartCalc.split('/')[0], 10)
      ? longFormMonth
        ? MONTH_NAMES[parseInt(DateStartCalc.split('/')[0], 10) - 1]
        : MONTH_NAMES_ABBR[parseInt(DateStartCalc.split('/')[0], 10) - 1]
      : null;
  const year = DateStartCalc && DateStartCalc.split('/')[2] ? DateStartCalc.split('/')[2] : '';
  const dateRange = `${monthName} ${startDay}-${endDay}, ${year}`;
  return dateRange;
};

export const sharedYearOnlyDateFormat = (DateStartCalc, DateEndCalc, longFormMonth) => {
  // Format Example: Nov 1 - Dec 4, 2020
  const startDay = DateStartCalc && DateStartCalc.split('/')[1] && DateStartCalc.split('/')[1] !== '0' ? DateStartCalc.split('/')[1] : '';
  const endDay = DateEndCalc && DateEndCalc.split('/')[1] && DateEndCalc.split('/')[1] !== '0' ? DateEndCalc.split('/')[1] : '';
  const startMonth =
    DateStartCalc && DateStartCalc.split('/')[0] && parseInt(DateStartCalc.split('/')[0], 10) ? parseInt(DateStartCalc.split('/')[0], 10) : null;
  const startMonthName = startMonth ? (longFormMonth ? MONTH_NAMES[startMonth - 1] : MONTH_NAMES_ABBR[startMonth - 1]) : '';
  const endMonth =
    DateStartCalc && DateEndCalc.split('/')[0] && parseInt(DateEndCalc.split('/')[0], 10) ? parseInt(DateEndCalc.split('/')[0], 10) : null;
  const endMonthName = endMonth ? (longFormMonth ? MONTH_NAMES[endMonth - 1] : MONTH_NAMES_ABBR[endMonth - 1]) : '';
  const year = DateStartCalc && DateStartCalc.split('/')[2] ? DateStartCalc.split('/')[2] : '';
  return `${startMonthName + (startDay !== '' ? ' ' : '') + startDay} - ${endMonthName}${endDay !== '' ? ' ' : ''}${endDay}, ${year}`;
};

export const formatDateForPostDetails = (dateTimeString) => {
  // Receives UTC date, returns date in local time
  let localTimeString = dateTimeString ? moment.utc(dateTimeString).toDate() : null;
  if (dateTimeString) localTimeString = moment(localTimeString).format('MM.DD.YYYY');
  return localTimeString;
};

export const formatSimpleDate = (dateTime) => {
  let formattedDate = dateTime ? new Date(dateTime) : null;
  if (formattedDate) formattedDate = `${formattedDate.getMonth() + 1}/${formattedDate.getDate()}/${formattedDate.getFullYear()}`;
  return formattedDate;
};

export const dateToShortDate = (date) => {
  let shortDate = date !== null && date !== '' ? new Date(date) : null;
  shortDate =
    shortDate && shortDate.getFullYear() && shortDate.getFullYear().toString()
      ? `${shortDate.getMonth() + 1}/${shortDate.getDate()}/${shortDate.getFullYear().toString().substring(2)}`
      : '';
  return shortDate;
};

export const utcDateTimeToShortDateTime = (dateTime) => {
  const time = dateTime.toString().split(' ')[4];
  const hour =
    time && time.split(':').length > 1
      ? parseInt(time.split(':')[0], 10) === 12
        ? 12
        : parseInt(time.split(':')[0], 10) > 12
        ? parseInt(time.split(':')[0], 10) - 12
        : parseInt(time.split(':')[0], 10)
      : null;
  const minutes = hour ? time.split(':')[1] : '';
  const amPm = hour ? (parseInt(time.split(':')[0], 10) >= 12 ? 'PM' : 'AM') : '';
  const formattedDateTime = dateToShortDate(dateTime) + (hour ? ` ${hour}:${minutes}${amPm}` : '');
  return formattedDateTime;
};

export const formatTimeRangeForPostsTableDisplay = (start, end) => {
  const startHour = start ? parseInt(start.substr(0, start.indexOf(':')), 10) : null;
  const startDisplayTime =
    startHour === 0 ? '12 AM ' : startHour ? (startHour < 12 ? `${startHour}AM` : startHour === 12 ? `${startHour}PM` : `${startHour - 12}PM`) : null;
  const endHour = end ? parseInt(end.substr(0, end.indexOf(':')), 10) : null;
  const endDisplayTime =
    endHour === 0 ? '12 AM ' : endHour ? (endHour < 12 ? `${endHour}AM` : endHour === 12 ? `${endHour}PM` : `${endHour - 12}PM`) : null;
  let returnedTimeRange = '';

  if (start && end) {
    returnedTimeRange = `${startDisplayTime} - ${endDisplayTime}`;
  } else if (startHour !== null && endHour === null) {
    returnedTimeRange = startDisplayTime;
  }
  return returnedTimeRange;
};

export const formatPostDateRangeForPostsTable = (DateStartCalc, DateEndCalc) => {
  const dateStart = formatShortFormDate(DateStartCalc);

  const dateEnd = DateEndCalc === DateStartCalc ? null : formatShortFormDate(DateEndCalc);
  let returnedDateRange = '';
  if (dateEnd) {
    returnedDateRange = `${dateStart} - ${dateEnd}`;
  } else {
    returnedDateRange = dateStart;
  }
  return returnedDateRange;
};

export const formatDateRangeForPostsTableDisplay = (DateStartCalc, DateEndCalc) => {
  let formattedDateRange = DateStartCalc;
  if (DateStartCalc && DateEndCalc && DateStartCalc !== DateEndCalc) {
    formattedDateRange += ` - ${DateEndCalc}`;
  }
  return formattedDateRange;
};

export const formatPostItemDateRange = (DateStartCalc, DateEndCalc) => {
  let dateRange = formatLongFormDate(DateStartCalc);
  // Only add end date if DateEndCalc is present && start and end date are not the same
  if (DateEndCalc && DateStartCalc !== DateEndCalc) {
    // If start and end date are different, but share a month & year, return consolidate the date range into the following format: Nov 1-30, 2020
    // If start and end date are different, but share a year, return consolidate the date range into the following format: Nov 1 - Dec 4, 2020
    // const formattedEndDate = formatLongFormDate(DateEndCalc);
    const datesAreSameMonth = areSameMonth(DateStartCalc, DateEndCalc);
    const datesAreSameYear = areSameYear(DateStartCalc, DateEndCalc);
    //
    const dateRangeHasANullDayDate =
      DateStartCalc.split('/')[1] && DateEndCalc.split('/')[1] && (DateStartCalc.split('/')[1] === '0' || DateEndCalc.split('/')[1] === '0');

    if (DateEndCalc === 'Ongoing') {
      dateRange += ' - Ongoing';
    } else if (dateRangeHasANullDayDate) {
      dateRange += ` - ${formatLongFormDate(DateEndCalc)}`;
    } else if (datesAreSameMonth && datesAreSameYear) {
      dateRange = sharedMonthAndYearDateFormat(DateStartCalc, DateEndCalc);
    } else if (datesAreSameYear) {
      dateRange = sharedYearOnlyDateFormat(DateStartCalc, DateEndCalc);
    } else {
      dateRange += ` - ${formatLongFormDate(DateEndCalc)}`;
    }
  }
  return dateRange;
};

export const formatPostDetailDateRange = (DateStartCalc, DateEndCalc) => {
  let dateRange = formatLongFormDate(DateStartCalc, true);
  // Only add end date if DateEndCalc is present && start and end date are not the same
  if (DateEndCalc && DateStartCalc !== DateEndCalc) {
    // If start and end date are different, but share a month & year, return consolidate the date range into the following format: Nov 1-30, 2020
    // If start and end date are different, but share a year, return consolidate the date range into the following format: Nov 1 - Dec 4, 2020
    // const formattedEndDate = formatLongFormDate(DateEndCalc, true);
    const datesAreSameMonth = areSameMonth(DateStartCalc, DateEndCalc);
    const datesAreSameYear = areSameYear(DateStartCalc, DateEndCalc);
    //
    const dateRangeHasANullDayDate =
      DateStartCalc.split('/')[1] && DateEndCalc.split('/')[1] && (DateStartCalc.split('/')[1] === '0' || DateEndCalc.split('/')[1] === '0');

    if (DateEndCalc === 'Ongoing') {
      dateRange += ' - Ongoing';
    } else if (dateRangeHasANullDayDate) {
      dateRange += ` - ${formatLongFormDate(DateEndCalc, true)}`;
    } else if (datesAreSameMonth && datesAreSameYear) {
      dateRange = sharedMonthAndYearDateFormat(DateStartCalc, DateEndCalc, true);
    } else if (datesAreSameYear) {
      dateRange = sharedYearOnlyDateFormat(DateStartCalc, DateEndCalc, true);
    } else {
      dateRange += ` - ${formatLongFormDate(DateEndCalc, true)}`;
    }
  }
  return dateRange;
};

export const formatRecentActivityTimestamp = (recentActivityGMTTimestamp) => {
  // To be completed: if timestamp is less than 24 hours ago, return the number of hours since timestamp, else return a short date
  // Receives UTC date, returns date in local time
  let localTimeString = recentActivityGMTTimestamp ? moment.utc(recentActivityGMTTimestamp).toDate() : null;
  if (recentActivityGMTTimestamp) localTimeString = moment(localTimeString).format('MM/DD/YYYY');
  return localTimeString;
};

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const displayDateFromMonthYear = (monthYearDateString) => {
  let displayDate = '';
  if (monthYearDateString.split('/')[0] === '0') {
    displayDate = monthYearDateString.split(' ')[0].split('/')[2];
  } else {
    displayDate = `${monthNames[monthYearDateString.split('/')[0] - 1]} ${monthYearDateString.split(' ')[0].split('/')[2]}`;
  }

  if (displayDate.includes('00:00:00')) {
    displayDate = displayDate.replace(' 00:00:00', '');
  }
  return displayDate;
};

export const formatDateRangeForPostFormDisplay = (StartDate, EndDate, onGoing) => {
  const startDate = StartDate !== null && StartDate !== '' ? new Date(StartDate) : null;
  const startDateDisplay = startDate
    ? typeof StartDate === 'string' && StartDate.includes('/0/')
      ? StartDate.includes('0/0/')
        ? StartDate.split('0/')[2]
        : displayDateFromMonthYear(StartDate)
      : `${monthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear().toString()}`
    : '';
  const endDate = EndDate !== null && EndDate !== '' ? new Date(EndDate) : null;
  const endDateDisplay = onGoing
    ? 'Ongoing'
    : typeof EndDate === 'string' && EndDate.includes('/0/')
    ? EndDate.includes('0/0/')
      ? EndDate.split('0/')[2]
      : displayDateFromMonthYear(EndDate)
    : endDate
    ? `${monthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear().toString()}`
    : null;
  let returnedDateRange = '';

  if (startDate && endDate) {
    if (onGoing === 'true' || onGoing === true) {
      returnedDateRange = `${startDateDisplay} - ${endDateDisplay}`;
    } else if (
      startDate.getDate() === endDate.getDate() &&
      startDate.getMonth() === endDate.getMonth() &&
      (typeof EndDate !== 'string' || !EndDate.includes('/00/')) &&
      startDate.getFullYear() === endDate.getFullYear()
    ) {
      returnedDateRange = startDateDisplay;
    } else {
      returnedDateRange = `${startDateDisplay} - ${endDateDisplay}`;
    }
  } else if (startDate !== null && endDate === null) {
    if (onGoing === 'true' || onGoing === true) {
      returnedDateRange = `${startDateDisplay} - ${endDateDisplay}`;
    } else {
      returnedDateRange = startDateDisplay;
    }
  }
  return returnedDateRange;
};

const getDoubleDigitMinutes = (date) => {
  return (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
};

export const formatTimeForDisplay = (dateTime) => {
  const newDateTime = dateTime !== null && dateTime !== '' ? new Date(dateTime) : null;
  const dateTimeHours = newDateTime
    ? newDateTime.getHours() > 12
      ? newDateTime.getHours() - 12
      : newDateTime.getHours() === 0
      ? '12'
      : newDateTime.getHours()
    : null;
  const returnedTime = newDateTime
    ? newDateTime.getHours() >= 12
      ? `${dateTimeHours}:${getDoubleDigitMinutes(newDateTime)} PM`
      : `${dateTimeHours}:${getDoubleDigitMinutes(newDateTime)} AM`
    : null;
  return returnedTime;
};

export const timeStringToDateTime = (timeString) => {
  const ts = `01/01/1970 ${timeString}`;
  const datetime = moment(ts).toDate();
  return datetime;
};

export const formatTimeRangeForPostFormDisplay = (StartDate, EndDate) => {
  const startDate = StartDate !== null && StartDate !== '' ? new Date(StartDate) : null;
  const endDate = EndDate !== null && EndDate !== '' ? new Date(EndDate) : null;
  const startHours = startDate
    ? startDate.getHours() > 12
      ? startDate.getHours() - 12
      : startDate.getHours() === 0
      ? '12'
      : startDate.getHours()
    : null;
  const startTime = startDate
    ? startDate.getHours() === 0 && startDate.getMinutes() === 0
      ? '12:00'
      : startDate.getHours() >= 12
      ? `${startHours}:${getDoubleDigitMinutes(startDate)} PM`
      : `${startHours}:${getDoubleDigitMinutes(startDate)} AM`
    : null;

  const endHours = endDate ? (endDate.getHours() > 12 ? endDate.getHours() - 12 : endDate.getHours() === 0 ? '12' : endDate.getHours()) : null;
  const endTime = endDate
    ? endDate.getHours() === 0 && endDate.getMinutes() === 0
      ? '12:00 AM'
      : endDate.getHours() >= 12
      ? `${endHours}:${getDoubleDigitMinutes(endDate)} PM`
      : `${endHours}:${getDoubleDigitMinutes(endDate)} AM`
    : null;
  let returnedTimeRange = '';

  if (startDate && endDate) {
    returnedTimeRange = `${startTime} - ${endTime}`;
  } else if (startDate !== null && endDate === null) {
    returnedTimeRange = startTime;
  }
  return returnedTimeRange;
};

export const formatDateTimeForDisplay = (dateTime, isUTC) => {
  const date = isUTC === true ? new Date(`${dateTime.toString()} UTC`) : new Date(dateTime);
  const timeZoneOffset = date.getTimezoneOffset();
  const today = new Date();

  const isToday = today.toDateString() === date.toDateString();
  const isYesterday = today.setDate(date.getDate() - (1 + timeZoneOffset / 60)) === date.toDateString();

  if (date) {
    const hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
    if (isToday) {
      return `Today ${hours}:${prependZeroToSingleDigitNumber(date.getMinutes())} ${amPm}`;
    }
    if (isYesterday) {
      return `Yesterday ${hours}:${prependZeroToSingleDigitNumber(date.getMinutes())} ${amPm}`;
    }
    return `${MONTH_NAMES[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} ${hours}:${prependZeroToSingleDigitNumber(
      date.getMinutes(),
    )} ${amPm}`;
  }
  return '';
};

// export const formatTimeRangeForDisplay

export const formatDateWithNullDateForDisplay = (date) => {
  const updatedDate = new Date(date);
  if (date) {
    return `${MONTH_NAMES[updatedDate.getMonth()]} ${updatedDate.getFullYear()}`;
  }
  return '';
};

export const isFormValid = (updatedFormControls) => {
  let formIsValid = true;
  for (const inputIdentifier in updatedFormControls) {
    formIsValid = updatedFormControls[inputIdentifier].valid && formIsValid;
  }
  return formIsValid;
};

export const getAge = (birthdateString, compDateString) => {
  const compDate = new Date(compDateString);
  const birthDate = new Date(birthdateString);
  let age = compDate.getFullYear() - birthDate.getFullYear();
  const m = compDate.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && compDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const sortArrayOfObjectsAlphabetically = (objArray, property, order) => {
  const sortedArray = objArray.sort((a, b) => {
    const textA = a[property] ? a[property].toUpperCase() : '';
    const textB = b[property] ? b[property].toUpperCase() : '';
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  if (order === 'asc') sortedArray.reverse();
  return sortedArray;
};

export const sortAlphabeticallyWithEmojiSupport = (objArray, property) => {
  return objArray.sort((a, b) => {
    const textA = stripEmojis(a[property].toUpperCase()).replace(/\s/g, '');
    const textB = stripEmojis(b[property].toUpperCase()).replace(/\s/g, '');
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
};

export const includesEmoji = (string) => {
  const emojiRegex =
    // eslint-disable-next-line max-len
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  return emojiRegex.test(string);
};

export const stripEmojis = (string) => {
  return string.replace(
    // eslint-disable-next-line max-len
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
    '',
  );
};

export const arraysEqual = (_arr1, _arr2) => {
  if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false;
  const arr1 = _arr1.concat().sort();
  const arr2 = _arr2.concat().sort();
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};

export const sortStringsWithinArrayOfObjects = (arrayOfObjects, valueName, sortDirection) => {
  let sortedObject = arrayOfObjects.sort((a, b) => {
    const nameA = a[valueName] ? a[valueName].toUpperCase() : null; // ignore upper and lowercase
    const nameB = b[valueName] ? b[valueName].toUpperCase() : null; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });

  if (sortDirection === 'desc') sortedObject = sortedObject.reverse();

  return sortedObject;
};

export const sortArrayOfObjectsByDateAsc = (arrayOfObjects, valueName) => {
  return (arrayOfObjects || []).sort((a, b) => {
    const dateA = new Date(a[valueName]);
    const dateB = new Date(b[valueName]);
    return dateA - dateB;
  });
};

export const sortArrayOfObjectsByDateTimeDesc = (arrayOfObjects, valueName) => {
  return arrayOfObjects.sort((a, b) => {
    const dateTimeA = new Date(a[valueName]).getTime();
    const dateTimeB = new Date(b[valueName]).getTime();
    return dateTimeB - dateTimeA;
  });
};

export const sortDateWithinArrayOfObjects = (arrayOfObjects, valueName, sortDirection) => {
  let sortedObject = arrayOfObjects.sort((a, b) => {
    const dateA = new Date(a[valueName]);
    const dateB = new Date(b[valueName]);
    return dateA - dateB;
  });
  sortedObject = sortDirection === 'desc' ? sortedObject.reverse() : sortedObject;
  return sortedObject;
};

export const extractPrivateLog = (logs) => {
  const privateLog =
    logs.length > 0 && logs.filter((log) => log.Visibility === 'Private').length > 0 ? logs.filter((log) => log.Visibility === 'Private')[0] : null;
  return privateLog;
};

export const sortLogNamesForDisplay = (logs) => {
  let sortedLogs = sortStringsWithinArrayOfObjects(logs, 'Name', 'asc');
  const privateLog =
    sortedLogs.length > 0 && sortedLogs.filter((log) => log.Visibility === 'Private').length > 0
      ? sortedLogs.filter((log) => log.Visibility === 'Private')[0]
      : null;
  if (privateLog) {
    sortedLogs = sortedLogs.filter((log) => log !== privateLog);
    sortedLogs.unshift(privateLog);
  }
  return sortedLogs;
};

export const getFullYearFromStringDate = (dateCalc) => {
  const fullYear = dateCalc && dateCalc.split('/') && dateCalc.split('/').length === 3 ? dateCalc.split('/')[2] : '';
  return fullYear;
};

export const getDaysInMonth = (month = THIS_MONTH, year = THIS_YEAR) => {
  const lastDate = new Date(year, month + 1, 0);
  return lastDate.getDate();
};

export const seasons = [
  {
    name: 'Spring',
    monthStart: 2,
    monthEnd: 4,
  },
  {
    name: 'Summer',
    monthStart: 5,
    monthEnd: 7,
  },
  {
    name: 'Fall',
    monthStart: 8,
    monthEnd: 10,
  },
  {
    name: 'Winter',
    monthStart: 11,
    monthEnd: 1,
  },
];

export const isSameSeason = (dateCalc, baseDateCalc) => {
  if (dateCalc === '' && baseDateCalc !== '') return false;
  const baseMonth = baseDateCalc.split('/')[0];
  const basedateSeason = getSeasonFromMonth(baseMonth);
  const compMonth = dateCalc.split('/')[0];
  const dateSeason = getSeasonFromMonth(compMonth);
  return basedateSeason === dateSeason;
};

export const isSameYear = (dateCalc, baseDateCalc) => {
  if (dateCalc === '' && baseDateCalc !== '') return false;
  const baseYear = baseDateCalc.split('/')[2];
  const compYear = dateCalc.split('/')[2];
  return baseYear === compYear;
};

export const getSeason = (dateCalc) => {
  let season = '';
  if (dateCalc && dateCalc.split('/') && dateCalc.split('/').length === 3) {
    const baseMonth = dateCalc.split('/')[0];
    season = getSeasonFromMonth(baseMonth);
  }
  return season;
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
};

export const getSeasonFromMonth = (monthStringNumber) => {
  const monthNumber = monthStringNumber && parseInt(monthStringNumber, 10) ? parseInt(monthStringNumber, 10) - 1 : null;
  let season = '';
  if (monthNumber !== null) {
    if (monthNumber >= 11 || monthNumber <= 1) {
      season = 'Winter';
    } else if (monthNumber > 1 && monthNumber < 5) {
      season = 'Spring';
    } else if (monthNumber >= 5 && monthNumber < 8) {
      season = 'Summer';
    } else {
      season = 'Fall';
    }
  }
  return season;
};

export const removeURLParameter = (url, parameter) => {
  // prefer to use l.search if you have a location/link object
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);

    // reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0; ) {
      // idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
  }
  return url;
};

export const colors = [
  {
    name: 'aquamarine',
    rgb: 'rgb(66, 180, 180)',
  },
  {
    name: 'beachblue',
    rgb: 'rgb(5, 132, 171)',
  },
  {
    name: 'bloodred',
    rgb: 'rgb(200, 0, 0)',
  },
  {
    name: 'brownbear',
    rgb: 'rgb(140, 120, 94)',
  },
  {
    name: 'chai',
    rgb: 'rgb(184, 143, 94)',
  },
  {
    name: 'cream',
    rgb: 'rgb(232, 227, 191)',
  },
  {
    name: 'creamsicle',
    rgb: 'rgb(243, 151, 84)',
  },
  {
    name: 'forest',
    rgb: 'rgb(8, 115, 78)',
  },
  {
    name: 'greywhale',
    rgb: 'rgb(171, 173, 170)',
  },
  {
    name: 'lemonyellow',
    rgb: 'rgb(239, 221, 64)',
  },
  {
    name: 'mint',
    rgb: 'rgb(69, 191, 85)',
  },
  {
    name: 'bloodorange',
    rgb: 'rgb(234, 86, 48)',
  },
  {
    name: 'pinkrose',
    rgb: 'rgb(236, 186, 174)',
  },
  {
    name: 'plum',
    rgb: 'rgb(120, 90, 164)',
  },
  {
    name: 'raspberry',
    rgb: 'rgb(186, 44, 105)',
  },
  {
    name: 'seagreen',
    rgb: 'rgb(184, 200, 164)',
  },
  {
    name: 'sky',
    rgb: 'rgb(108, 162, 183)',
  },
  {
    name: 'slate',
    rgb: 'rgb(96, 117, 140)',
  },
];

export const categories = [
  'Basics',
  'Bigs',
  'Birthdays',
  'Celebrations',
  'Faves',
  'Fitness',
  'Growth',
  'Hardships',
  'Health',
  'Journeys',
  'Learning',
  'Moments',
  'Places',
  'Purpose',
  'Relationships',
  'Spirituality',
  'Work',
  'Other',
];

export const categoryImages = [
  {
    name: 'Basics',
    image: Basics,
  },
  {
    name: 'Bigs',
    image: Bigs,
  },
  {
    name: 'Birthdays',
    image: Birthdays,
  },
  {
    name: 'Celebrations',
    image: Celebrations,
  },
  {
    name: 'Faves',
    image: Faves,
  },
  {
    name: 'Fitness',
    image: Fitness,
  },
  {
    name: 'Growth',
    image: Growth,
  },
  {
    name: 'Hardships',
    image: Hardships,
  },
  {
    name: 'Health',
    image: Health,
  },
  {
    name: 'Journeys',
    image: Journeys,
  },
  {
    name: 'Learning',
    image: Learning,
  },
  {
    name: 'Moments',
    image: Moments,
  },
  {
    name: 'Places',
    image: Places,
  },
  {
    name: 'Purpose',
    image: Purpose,
  },
  {
    name: 'Relationships',
    image: Relationships,
  },
  {
    name: 'Spirituality',
    image: Spirituality,
  },
  {
    name: 'Work',
    image: Work,
  },
  {
    name: 'Other',
    image: Other,
  },
];

export const formImages = [
  {
    name: 'Calendar',
    image: Calendar,
  },
  {
    name: 'Lightbulb',
    image: Lightbulb,
  },
  {
    name: 'Camera',
    image: Camera,
  },
  {
    name: 'Tags',
    image: Tags,
  },
  {
    name: 'List',
    image: List,
  },
  {
    name: 'Map',
    image: Map,
  },
  {
    name: 'Users',
    image: UserGroup,
  },
];

export const importantPlaceIcons = [
  { name: 'heart', image: Heart, markerSVG: HeartMarker },
  { name: 'home', image: Home, markerSVG: HomeMarker },
  { name: 'home-heart', image: HomeHeart, markerSVG: HomeHeartMarker },
  { name: 'campground', image: Campground, markerSVG: CampgroundMarker },
  { name: 'building', image: Building, markerSVG: BuildingMarker },
  { name: 'key', image: Key, markerSVG: KeyMarker },
  { name: 'user-circle', image: UserCircle, markerSVG: UserCircleMarker },
  { name: 'users', image: Users, markerSVG: UsersMarker },
  { name: 'user-friends', image: UserFriends, markerSVG: UserFriendsMarker },
  { name: 'child', image: Child, markerSVG: ChildMarker },
  { name: 'baby-carriage', image: BabyCarriage, markerSVG: BabyCarriageMarker },
  { name: 'hand-heart', image: HandHeart, markerSVG: HandHeartMarker },
  { name: 'lightbulb', image: Lightbulb2, markerSVG: LightbulbMarker },
  { name: 'backpack', image: Backpack, markerSVG: BackpackMarker },
  { name: 'user-graduate', image: UserGraduate, markerSVG: UserGraduateMarker },
  { name: 'hammer', image: Hammer, markerSVG: HammerMarker },
  { name: 'toolbox', image: Toolbox, markerSVG: ToolboxMarker },
  { name: 'hands-helping', image: HandsHelping, markerSVG: HandsHelpingMarker },
  { name: 'sack-dollar', image: SackDollar, markerSVG: SackDollarMarker },
  { name: 'star-shooting', image: StarShooting, markerSVG: StarShootingMarker },
  { name: 'planet-moon', image: PlanetMoon, markerSVG: PlanetMoonMarker },
  { name: 'medal', image: Medal, markerSVG: MountainMarker },
  { name: 'dumbbell', image: Dumbbell, markerSVG: DumbbellMarker },
  { name: 'bicycle', image: Bicycle, markerSVG: BicycleMarker },
  { name: 'shoe-prints', image: ShoePrints, markerSVG: ShoePrintsMarker },
  { name: 'hiking', image: Hiking, markerSVG: HikingMarker },
  { name: 'baseball-ball', image: BaseballBall, markerSVG: BaseballBallMarker },
  { name: 'notes-medical', image: NotesMedical, markerSVG: NotesMedicalMarker },
  { name: 'user-md', image: UserMd, markerSVG: UserMdMarker },
  { name: 'hospital', image: Hospital, markerSVG: HospitalMarker },
  { name: 'spa', image: Spa, markerSVG: SpaMarker },
  { name: 'palette', image: Palette, markerSVG: PaletteMarker },
  { name: 'music', image: Music, markerSVG: MusicMarker },
  { name: 'ticket', image: Ticket, markerSVG: TicketMarker },
  { name: 'fire-alt', image: FireAlt, markerSVG: FireAltMarker },
  { name: 'paw', image: Paw, markerSVG: PawMarker },
  { name: 'rainbow', image: Rainbow, markerSVG: RainbowMarker },
  { name: 'car-side', image: CarSide, markerSVG: CarSideMarker },
  { name: 'telescope', image: Telescope, markerSVG: TelescopeMarker },
  { name: 'ghost', image: Ghost, markerSVG: GhostMarker },
  { name: 'heart-broken', image: HeartBroken, markerSVG: HeartBrokenMarker },
  { name: 'flower-daffodil', image: FlowerDaffodil, markerSVG: FlowerDaffodilMarker },
  { name: 'dove', image: Dove, markerSVG: DoveMarker },
  { name: 'praying-hands', image: PrayingHands, markerSVG: PrayingHandsMarker },
  { name: 'anchor', image: Anchor, markerSVG: AnchorMarker },
  { name: 'hand-sparkles', image: HandSparkles, markerSVG: HandSparklesMarker },
  { name: 'landmark', image: Landmark, markerSVG: LandmarkMarker },
  { name: 'rocket-launch', image: RocketLaunch, markerSVG: RocketLaunchMarker },
  { name: 'seedling', image: Seedling, markerSVG: SeedlingMarker },
  { name: 'mountain', image: Mountain, markerSVG: MountainMarker },
  { name: 'tree', image: Tree, markerSVG: TreeMarker },
  { name: 'sun', image: Sun, markerSVG: SunMarker },
  { name: 'water', image: Water, markerSVG: WaterMarker },
  { name: 'snowflake', image: Snowflake, markerSVG: SnowflakeMarker },
  { name: 'birthday-cake', image: BirthdayCake, markerSVG: BirthdayCakeMarker },
  { name: 'glass-cheers', image: GlassCheers, markerSVG: GlassCheersMarker },
  { name: 'utensils', image: Utensils, markerSVG: UtensilsMarker },
  { name: 'mug-hot', image: MugHot, markerSVG: MugHotMarker },
  { name: 'bullseye-arrow', image: BullseyeArrow, markerSVG: BullseyeArrowMarker },
  { name: 'wifi', image: Wifi, markerSVG: WifiMarker },
  { name: 'star-of-life', image: StarOfLife, markerSVG: StarOfLifeMarker },
  { name: 'badge', image: Badge, markerSVG: BadgeMarker },
  { name: 'map-pin', image: MapPin, markerSVG: MapPinMarker },
  { name: 'bookmark', image: Bookmark, markerSVG: BookmarkMarker },
  { name: 'books', image: Books, markerSVG: BooksMarker },
  { name: 'moon-stars', image: MoonStars, markerSVG: MoonStarsMarker },
];

export const rizaResponsesList = [
  '❤️ i love this! ',
  '👁️ i see you and i love you ',
  '🤗 thank you! ',
  '💫 SUCH fun times ',
  "💧 i'm sad and sorry ",
  '🚣🏽‍♀️ this is hard ',
  '🕊️ thinking of and praying for you ',
  '🙌🏽 i believe you can do this ',
  '🤕 please feel better soon ',
  "😰 don't give up - keeping you accountable ",
  '💡 knowledge = power! ',
  '💪🏽 work those skills yesss ',
  '🏅 woohoo, cheering you on! ',
];

export const helpVideos = [
  {
    id: 'notifications',
    name: 'Brian',
    length: '0:43',
    image: NotificationsImage,
    category: 'Notifications',
    description: 'Set your notification preferences with a few easy clicks! ',
    videoSrc: 'https://videokits-static.s3.amazonaws.com/riza/riza/help/notifications_help.mp4',
  },
  {
    id: 'gift-post',
    name: 'Sarah',
    length: '2:51',
    image: GiftPostImage,
    category: 'Gift a Post',
    description: 'One of members’ favorite features. Find out how easy it is to gift and to get gift posts!',
    videoSrc: 'https://videokits-static.s3.amazonaws.com/riza/riza/help/gift_post_help.mp4',
  },
  {
    id: 'category-types',
    name: 'Annie',
    length: '1:58',
    image: CategoryImage,
    category: 'Category Types',
    description:
      'Riza is all about all of life - our relationships AND our learning AND our celebrations AND our health AND the fun AND ' +
      'the hard parts, and much MORE. Pay attention to each aspect using Riza tools.',
    videoSrc: 'https://videokits-static.s3.amazonaws.com/riza/riza/help/category_help.mp4',
  },
  {
    id: 'contributions',
    name: 'Grecia',
    length: '2:43',
    image: ContributionsImage,
    category: 'Contributions',
    description:
      'Make the most premium Riza responses using the contributions feature. Your relationships will get deeper and stronger, ' +
      'and you will be amazing!',
    videoSrc: 'https://videokits-static.s3.amazonaws.com/riza/riza/help/contributions_help.mp4',
  },
  {
    id: 'create-post',
    name: 'Ben',
    length: '1:17',
    image: CreatePostImage,
    category: 'Create a Post',
    description:
      'Take only a few seconds to create a quick post. Or craft more detailed posts. Reflect about the present or the past or even the future. ' +
      'Posting on Riza helps you remember and share what matters most to you in life with people you care about the most.',
    videoSrc: 'https://videokits-static.s3.amazonaws.com/riza/riza/help/create_post_help.mp4',
  },
];

const loremIpsum =
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. ' +
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. ' +
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. ' +
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. ' +
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. ' +
  'Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit. Learn about lorem ipsum dolor sit amet, consectetur adipisicing elit.';

export const faqs = [
  {
    id: '1',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
  {
    id: '2',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
  {
    id: '3',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
  {
    id: '4',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
  {
    id: '5',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
  {
    id: '6',
    title: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit?',
    description: loremIpsum,
  },
];

export const getRgbFromColorName = (colorName) => {
  return colors.find((color) => color.name === colorName) ? colors.find((color) => color.name === colorName).rgb : null;
};
